// Gemeinsame Helfer für die Logbuch-Bausteine (LearningJournalPageV2)

export const formatDuration = (minutes) => {
  if (!minutes || minutes <= 0) return '0 Min';
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} Min`;
  return rest === 0 ? `${hours} Std` : `${hours} Std ${rest} Min`;
};

// Kurzform fuer enge Kennzahlen (Okt 2026, wie im Spot „10 Std“): ab einer
// Stunde auf volle Stunden gerundet, darunter Minuten. Die lange Form steht
// weiter in jeder Zeile.
export const formatDurationShort = (minutes) => {
  if (!minutes || minutes <= 0) return '0 Min';
  if (minutes < 60) return `${minutes} Min`;
  return `${Math.round(minutes / 60)} Std`;
};

// Datum einer Logbuchzeile: „8.10.2026“ (wie im Spot und bisher in der App).
export const formatJournalDate = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('de-DE');
};

// Lernpartner:in aus GET /learning-journal/sessions -> Person fuer AvatarStack.
export const partnerToPerson = (partner) => ({
  id: partner.id,
  name: partner.displayName,
  src: partner.avatar || undefined,
});

// Sessions + manuelle Eintraege chronologisch gemischt (Logbuch-Seite und
// geteilte Ansicht sortieren identisch)
export const buildJournalTimeline = (sessions = [], entries = []) => [
  ...sessions.map(s => ({ type: 'session', date: new Date(s.date || s.createdAt), data: s })),
  ...entries.map(e => ({ type: 'entry', date: new Date(e.occurredAt || e.createdAt), data: e })),
].sort((a, b) => b.date - a.date);

// Link zum geteilten Logbuch. Im Browser die eigene Origin (stimmt in Dev,
// Staging und Prod ohne Konfiguration); in der nativen App zeigt
// window.location.origin auf capacitor://localhost - dort gilt die vom
// Backend gebaute URL (FRONTEND_URL).
export const buildShareUrl = (share, { isNative = false } = {}) => (
  isNative && share.shareUrl
    ? share.shareUrl
    : `${window.location.origin}/shared/journal/${share.token}`
);
